(function () {
  "use strict";

  angular.module("appback").controller("DashboardController", DashboardController);

  DashboardController.$inject = ["$http", "$timeout"];

  function DashboardController($http, $timeout) {
    var vm = this;

    vm.searchQuery = "";
    vm.kpis = [];
    vm.aiActions = [];
    vm.responseTimes = { average: "", days: [] };
    vm.channels = [];
    vm.connectedChannels = [];
    vm.conversations = [];
    vm.conversationsPage = 1;
    vm.conversationsPageSize = 10;
    vm.conversationsTotal = 0;

    vm.replyDraft = emptyReplyDraft();
    vm.contactAssign = emptyContactAssign();

    vm.acceptAction = acceptAction;
    vm.rejectAction = rejectAction;
    vm.toggleEdit = toggleEdit;
    vm.saveEdit = saveEdit;
    vm.replyToConversation = replyToConversation;
    vm.discardConversation = discardConversation;
    vm.confirmDiscardConversation = confirmDiscardConversation;
    vm.insertSuggestedReply = insertSuggestedReply;
    vm.toggleReplyNote = toggleReplyNote;
    vm.submitReply = submitReply;
    vm.conversationsTotalPages = conversationsTotalPages;
    vm.goToConversationsPage = goToConversationsPage;
    vm.openAssignContact = openAssignContact;
    vm.searchContacts = searchContacts;
    vm.assignExistingContact = assignExistingContact;
    vm.newContact = newContact;
    vm.editContact = editContact;
    vm.cancelContactForm = cancelContactForm;
    vm.saveAndAssignContact = saveAndAssignContact;
    vm.showContactSearch = showContactSearch;
    vm.cancelContactSearch = cancelContactSearch;
    vm.isValidEmail = isValidEmail;

    activate();

    function activate() {
      var discardModalEl = document.getElementById("discardConfirmModal");
      if (discardModalEl) {
        discardModalEl.addEventListener("hidden.bs.modal", function () {
          pendingDiscard = null;
        });
      }

      $http.get("/backend/dashboard/kpis").then(function (res) {
        vm.kpis = res.data;
      });

      $http.get("/backend/dashboard/ai-actions").then(function (res) {
        vm.aiActions = res.data;
      });

      $http.get("/backend/dashboard/response-times").then(function (res) {
        vm.responseTimes = res.data;
        renderResponseTimesChart(res.data);
      });

      $http.get("/backend/dashboard/channels").then(function (res) {
        vm.channels = res.data;
        renderChannelsChart(res.data);
      });

      $http.get("/backend/dashboard/connected-channels").then(function (res) {
        vm.connectedChannels = res.data;
      });

      loadConversations();
    }

    function loadConversations() {
      return $http
        .get("/backend/dashboard/conversations", {
          params: { page: vm.conversationsPage, pageSize: vm.conversationsPageSize },
        })
        .then(function (res) {
          vm.conversations = res.data.items || [];
          vm.conversationsTotal = res.data.total || 0;
          vm.conversationsPage = res.data.page || 1;
          vm.conversationsPageSize = res.data.pageSize || vm.conversationsPageSize;
        });
    }

    function conversationsTotalPages() {
      return Math.max(1, Math.ceil(vm.conversationsTotal / vm.conversationsPageSize));
    }

    function goToConversationsPage(page) {
      if (page < 1 || page > conversationsTotalPages()) {
        return;
      }
      vm.conversationsPage = page;
      loadConversations();
    }

    function acceptAction(action) {
      postForm("/backend/dashboard/accept-ai-action", { id: action.id }).then(function () {
        vm.aiActions = vm.aiActions.filter(function (a) {
          return a.id !== action.id;
        });
      });
    }

    function rejectAction(action) {
      postForm("/backend/dashboard/reject-ai-action", { id: action.id }).then(function () {
        vm.aiActions = vm.aiActions.filter(function (a) {
          return a.id !== action.id;
        });
      });
    }

    function toggleEdit(action) {
      action.editing = !action.editing;
    }

    function saveEdit(action) {
      postForm("/backend/dashboard/update-ai-action", {
        id: action.id,
        suggestedReply: action.suggestedReply,
      }).then(function () {
        action.editing = false;
      });
    }

    function postForm(url, data) {
      return $http.post(url, jQuery.param(data), {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
    }

    // -- Chart.js (cargado como CDN global en backend\assets\AppAsset::$js,
    // antes que este bundle) para "Tendencias de Tiempo de Respuesta" y
    // "Mensajes por Canal". Se instancian una sola vez contra el <canvas> y
    // después solo se actualizan datos + colores, en vez de recrearlos en
    // cada refresco.

    var BRAND_SECONDARY = "#4b41e1";
    var BRAND_TERTIARY = "#4edea3";

    var responseTimesChart = null;

    function renderResponseTimesChart(data) {
      var canvas = document.getElementById("responseTimesChart");
      if (!canvas || typeof Chart === "undefined") {
        return;
      }

      var days = data.days || [];
      var labels = days.map(function (d) {
        return d.label;
      });
      var values = days.map(function (d) {
        return d.hours;
      });
      var colors = days.map(function (d) {
        return d.highlight ? BRAND_SECONDARY : BRAND_TERTIARY;
      });

      if (responseTimesChart) {
        responseTimesChart.data.labels = labels;
        responseTimesChart.data.datasets[0].data = values;
        responseTimesChart.data.datasets[0].backgroundColor = colors;
        responseTimesChart.update();
        return;
      }

      responseTimesChart = new Chart(canvas.getContext("2d"), {
        type: "bar",
        data: {
          labels: labels,
          datasets: [{ data: values, backgroundColor: colors, borderRadius: 4, maxBarThickness: 32 }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: { callbacks: { label: function (ctx) { return ctx.parsed.y + "h"; } } },
          },
          scales: {
            y: { beginAtZero: true, ticks: { stepSize: 1 } },
            x: { grid: { display: false } },
          },
        },
      });
    }

    var channelsChart = null;

    function renderChannelsChart(channels) {
      var canvas = document.getElementById("channelsChart");
      if (!canvas || typeof Chart === "undefined") {
        return;
      }

      channels = channels || [];
      var labels = channels.map(function (c) {
        return c.name;
      });
      var values = channels.map(function (c) {
        return c.percent;
      });
      var colors = channels.map(function (c) {
        return c.color || BRAND_SECONDARY;
      });

      if (channelsChart) {
        channelsChart.data.labels = labels;
        channelsChart.data.datasets[0].data = values;
        channelsChart.data.datasets[0].backgroundColor = colors;
        channelsChart.update();
        return;
      }

      channelsChart = new Chart(canvas.getContext("2d"), {
        type: "bar",
        data: {
          labels: labels,
          datasets: [{ data: values, backgroundColor: colors, borderRadius: 4, maxBarThickness: 18 }],
        },
        options: {
          indexAxis: "y",
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: { callbacks: { label: function (ctx) { return ctx.parsed.x + "%"; } } },
          },
          scales: {
            x: { beginAtZero: true, max: 100, ticks: { callback: function (v) { return v + "%"; } } },
            y: { grid: { display: false } },
          },
        },
      });
    }

    function emptyReplyDraft() {
      return {
        conversation: null,
        text: "",
        note: "",
        showNote: false,
        suggestedReply: null,
        opportunity: null,
        activity: [],
        thread: [],
        role: null,
        senderAddress: null,
        avatarUrl: null,
        loading: false,
      };
    }

    function replyToConversation(conversation) {
      vm.replyDraft = emptyReplyDraft();
      vm.replyDraft.conversation = conversation;
      vm.replyDraft.loading = true;
      getReplyModal().show();

      $http.get("/backend/dashboard/conversation-detail", { params: { id: conversation.id } }).then(function (res) {
        vm.replyDraft.suggestedReply = res.data.suggestedReply;
        vm.replyDraft.opportunity = res.data.opportunity;
        vm.replyDraft.activity = res.data.activity || [];
        vm.replyDraft.thread = res.data.thread || [];
        vm.replyDraft.role = res.data.role;
        vm.replyDraft.senderAddress = res.data.senderAddress;
        vm.replyDraft.avatarUrl = res.data.avatarUrl;
        vm.replyDraft.loading = false;
      });
    }

    function insertSuggestedReply() {
      if (vm.replyDraft.suggestedReply) {
        vm.replyDraft.text = vm.replyDraft.suggestedReply;
      }
    }

    function toggleReplyNote() {
      vm.replyDraft.showNote = !vm.replyDraft.showNote;
    }

    function submitReply() {
      var conversation = vm.replyDraft.conversation;
      var reply = (vm.replyDraft.text || "").trim();
      if (!conversation || reply === "") {
        return;
      }

      postForm("/backend/dashboard/reply-conversation", {
        id: conversation.id,
        reply: reply,
        note: vm.replyDraft.note || "",
      }).then(function () {
        vm.searchQuery = "";
        getReplyModal().hide();
        // Se recarga la página actual en vez de sacar la conversación del
        // array local: así el total y la cantidad de páginas quedan
        // correctos (puede entrar otra conversación a completar el hueco).
        loadConversations();
      });
    }

    var discardConfirmModal = null;
    var pendingDiscard = null;

    function getDiscardConfirmModal() {
      if (!discardConfirmModal) {
        discardConfirmModal = new bootstrap.Modal(document.getElementById("discardConfirmModal"));
      }
      return discardConfirmModal;
    }

    function discardConversation(conversation) {
      if (!conversation) {
        return;
      }

      pendingDiscard = conversation;
      getDiscardConfirmModal().show();
    }

    function confirmDiscardConversation() {
      if (!pendingDiscard) {
        return;
      }

      var conversation = pendingDiscard;
      pendingDiscard = null;
      getDiscardConfirmModal().hide();

      postForm("/backend/dashboard/discard-conversation", { id: conversation.id }).then(function () {
        loadConversations();
      });
    }

    var replyModal = null;

    function getReplyModal() {
      if (!replyModal) {
        replyModal = new bootstrap.Modal(document.getElementById("replyConversationModal"));
      }
      return replyModal;
    }

    function emptyContactAssign() {
      return {
        conversation: null,
        currentContact: null,
        loadingCurrent: false,
        showSearch: false,
        query: "",
        results: [],
        searching: false,
        saving: false,
        form: null,
      };
    }

    var contactSearchTimeout = null;
    var assignContactModal = null;

    function getAssignContactModal() {
      if (!assignContactModal) {
        assignContactModal = new bootstrap.Modal(document.getElementById("assignContactModal"));
      }
      return assignContactModal;
    }

    function openAssignContact(conversation) {
      vm.contactAssign = emptyContactAssign();
      vm.contactAssign.conversation = conversation;
      getAssignContactModal().show();

      if (conversation.contactoId) {
        loadCurrentContact(conversation.contactoId);
      } else {
        vm.contactAssign.showSearch = true;
      }
    }

    function loadCurrentContact(contactoId) {
      vm.contactAssign.loadingCurrent = true;
      $http
        .get("/backend/contacto/getcontact", { params: { id: contactoId } })
        .then(function (res) {
          if (res.data.success && res.data.data) {
            vm.contactAssign.currentContact = contactSummaryFromNode(res.data.data);
          }
        })
        .finally(function () {
          vm.contactAssign.loadingCurrent = false;
        });
    }

    function contactSummaryFromNode(c) {
      var nombre = (c.nombre || "").trim();
      var apellidos = (c.apellidos || "").trim();

      return {
        id: c.id,
        nombre: nombre,
        apellidos: apellidos,
        empresa: c.empresa || "",
        email: c.email || "",
        telefono: c.telefono || "",
        initials: ((nombre.charAt(0) || "") + (apellidos.charAt(0) || "")).toUpperCase() || "—",
      };
    }

    function showContactSearch() {
      vm.contactAssign.showSearch = true;
      vm.contactAssign.query = "";
      vm.contactAssign.results = [];
    }

    function cancelContactSearch() {
      vm.contactAssign.showSearch = false;
    }

    function searchContacts() {
      if (contactSearchTimeout) {
        $timeout.cancel(contactSearchTimeout);
      }

      contactSearchTimeout = $timeout(function () {
        var query = (vm.contactAssign.query || "").trim();
        if (query === "") {
          vm.contactAssign.results = [];
          return;
        }

        vm.contactAssign.searching = true;
        $http
          .get("/backend/dashboard/search-contacts", { params: { q: query } })
          .then(function (res) {
            vm.contactAssign.results = res.data.data || [];
          })
          .finally(function () {
            vm.contactAssign.searching = false;
          });
      }, 300);
    }

    function assignExistingContact(contact) {
      finishAssignContact(contact.id);
    }

    function newContact() {
      vm.contactAssign.form = {
        id: null,
        nombre: (vm.contactAssign.query || "").trim(),
        apellidos: "",
        empresa: "",
        email: "",
        telefono: "",
      };
    }

    function editContact(contact) {
      vm.contactAssign.form = angular.copy(contact);
    }

    function cancelContactForm() {
      vm.contactAssign.form = null;
    }

    function isValidEmail(email) {
      email = (email || "").trim();
      return email === "" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function saveAndAssignContact() {
      var form = vm.contactAssign.form;
      if (!form || !(form.nombre || "").trim() || !isValidEmail(form.email)) {
        return;
      }

      vm.contactAssign.saving = true;
      postForm("/backend/dashboard/save-contact", form)
        .then(function (res) {
          if (res.data.success) {
            finishAssignContact(res.data.data.id);
          }
        })
        .finally(function () {
          vm.contactAssign.saving = false;
        });
    }

    function finishAssignContact(contactoId) {
      var conversation = vm.contactAssign.conversation;
      if (!conversation) {
        return;
      }

      postForm("/backend/dashboard/assign-contact", {
        id: conversation.id,
        contactoId: contactoId,
      }).then(function (res) {
        if (res.data.success) {
          getAssignContactModal().hide();
          loadConversations();
        }
      });
    }
  }
})();
